import { defineStore } from 'pinia';
import {getDevApiBaseUrl} from "@/composables/utilities.js";

const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '')
const isDev = import.meta.env.MODE === 'development';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        login: localStorage.getItem('login') || '',
        userId: sessionStorage.getItem('userId') || '',
        buyerId: sessionStorage.getItem('buyerId') || '',
        userName: sessionStorage.getItem('userName') || '',
        rememberMe: localStorage.getItem('rememberMe') === 'true',
        token: sessionStorage.getItem('token') || null,
        company: sessionStorage.getItem('company') || '',
    }),

    actions: {
        async loginUser({ login, password, rememberMe }) {
            const baseUrl = isDev ? getDevApiBaseUrl() : API_BASE_URL;
            const url = `${baseUrl}/veriflogin`;

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ login, password }),
            });

            if (!response.ok) {
                let message = 'Identifiants invalides ou utilisateur non autorisé.';
                try {
                    const data = await response.json();
                    if (data?.message) message = data.message;
                } catch (e) {
                    // pas de JSON, on garde le message par défaut
                }
                throw new Error(message);
            }

            const data = await response.json();

            this.login = login;
            this.rememberMe = rememberMe;
            this.token = data.token || null;
            this.userId = data.id || '';
            this.userName = data.nom || '';
            this.buyerId = data.id_acheteur || '';

            this.company = data.id_societe != null ? String(data.id_societe) : null;

            // Session: stored in sessionStorage (disappears upon closing)
            sessionStorage.setItem('userId', this.userId);
            sessionStorage.setItem('buyerId', this.buyerId);
            sessionStorage.setItem('userName', this.userName);
            if (this.token) {
                sessionStorage.setItem('token', this.token);
            }
            if (this.company !== null) {
                sessionStorage.setItem('company', this.company);
            }

            // Remember Me : uniquement le login dans localStorage
            if (rememberMe) {
                localStorage.setItem('rememberMe', 'true');
                localStorage.setItem('login', login);
            } else {
                localStorage.removeItem('rememberMe');
                localStorage.removeItem('login');
            }
        },

        logoutUser() {

            // Nettoyer sessionStorage
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('userId');
            sessionStorage.removeItem('userName');
            sessionStorage.removeItem('buyerId');
            sessionStorage.removeItem('company');

            // Nettoyer localStorage (sauf rememberMe/login si activé)
            if (!this.rememberMe) {
                localStorage.removeItem('rememberMe');
                localStorage.removeItem('login');
            }

            this.$reset();

        },
    },
});
